import { render, staticRenderFns } from "./AssignUserToRole.vue?vue&type=template&id=21f5e602&"
import script from "./AssignUserToRole.vue?vue&type=script&lang=js&"
export * from "./AssignUserToRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports